import { render, staticRenderFns } from "./staffCollectedProduct.vue?vue&type=template&id=3394ab67&scoped=true"
import script from "./staffCollectedProduct.vue?vue&type=script&lang=js"
export * from "./staffCollectedProduct.vue?vue&type=script&lang=js"
import style0 from "./staffCollectedProduct.vue?vue&type=style&index=0&id=3394ab67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3394ab67",
  null
  
)

export default component.exports